import * as PlayerError from 'src/interfaces/PlayerError';

export const PLATFORM = PlayerError.Platforms.WEB;
export const URL_HELP_CENTER = 'https://help.hotmart.com';

export const COMMON_ERRORS: PlayerError.CommonErrorsType[] = [
  {
    code: PlayerError.CodeErrors.MEDIA_ERR_ABORTED,
    custom_code: PlayerError.CustomCodeErrors.MEDIA_ERR_ABORTED,
    category: 'MEDIA_ERR_ABORTED',
  },
  {
    code: PlayerError.CodeErrors.MEDIA_ERR_NETWORK,
    custom_code: PlayerError.CustomCodeErrors.MEDIA_ERR_NETWORK,
    category: 'MEDIA_ERR_NETWORK',
  },
  {
    code: PlayerError.CodeErrors.MEDIA_ERR_DECODE,
    custom_code: PlayerError.CustomCodeErrors.MEDIA_ERR_DECODE,
    category: 'MEDIA_ERR_DECODE',
  },
  {
    code: PlayerError.CodeErrors.MEDIA_ERR_SRC_NOT_SUPPORTED,
    custom_code: PlayerError.CustomCodeErrors.MEDIA_ERR_SRC_NOT_SUPPORTED,
    category: 'MEDIA_ERR_SRC_NOT_SUPPORTED',
  },
  {
    code: PlayerError.CodeErrors.MEDIA_ERR_ENCRYPTED,
    custom_code: PlayerError.CustomCodeErrors.MEDIA_ERR_ENCRYPTED,
    category: 'MEDIA_ERR_ENCRYPTED',
  },
  {
    code: PlayerError.CodeErrors.PLAYER_ERR_TIMEOUT,
    custom_code: PlayerError.CustomCodeErrors.PLAYER_ERR_TIMEOUT,
    category: 'PLAYER_ERR_TIMEOUT',
  },
  {
    code: PlayerError.CodeErrors.PLAYER_ERR_NO_SRC,
    custom_code: PlayerError.CustomCodeErrors.PLAYER_ERR_NO_SRC,
    category: 'PLAYER_ERR_NO_SRC',
  },
  {
    code: PlayerError.CodeErrors.UNKNOWN,
    custom_code: PlayerError.CustomCodeErrors.UNKNOWN,
    category: 'unknown',
  },
];
